<template>
  <grape-component/>
</template>

<script>
import GrapeComponent from '@/spa/components/board/grape/BoardGrape';

export default {
  name: 'GrapePage',
  components: {
    GrapeComponent,
  },
};
</script>



// WEBPACK FOOTER //
// src/spa/pages/contents/GrapePage.vue